import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';

import { AccountService, AlertService } from '@app/_services';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '@app/_models';

@Component({ selector: 'app-user-list',
templateUrl: 'list.component.html' })
export class ListComponent implements OnInit, OnDestroy {
    users = null;
    id:string;
    user:User;
    isUserShow = false;
    isLoading = true;
    private destroy$ = new Subject<void>();

    constructor(private accountService: AccountService,
        private route: ActivatedRoute,
        private router: Router,
        private alertService: AlertService,
    ) {}

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.user = this.accountService.userValue;
        if (this.user.role == 'admin')
            this.accountService.getByDealerId(this.id)
                .pipe(takeUntil(this.destroy$), first())
                .subscribe({
                    next: users => { this.users = users; this.isLoading = false; },
                    error: () => { this.alertService.error('Failed to load users'); this.isLoading = false; }
                });
        else
            this.accountService.getByDealerId(this.user.dealerId)
                .pipe(takeUntil(this.destroy$), first())
                .subscribe({
                    next: users => {
                        this.users = users.filter(x => (x.role == "executive") || (x.role == "manager"));
                        this.isLoading = false;
                    },
                    error: () => { this.alertService.error('Failed to load users'); this.isLoading = false; }
                });

        if (this.user.role=="manager")
        {
            this.isUserShow = true;
        }
    
    }

    deleteUser(id: string) {
        const user = this.users.find(x => x.id === id);
        user.isDeleting = true;
        this.accountService.delete(id)
            .pipe(takeUntil(this.destroy$), first())
            .subscribe({
                next: () => this.users = this.users.filter(x => x.id !== id),
                error: () => { this.alertService.error('Failed to delete user'); user.isDeleting = false; }
            });
    }
    userShowToggle(){
        this.isUserShow = !this.isUserShow;
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
